import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortHeader, Sort } from '@angular/material/sort';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { Account } from 'projects/internal/r1-component-library/src/lib/components/appcloud-login/appcloud-credentials/appcloud-credentials.model';
import { PagedSearch } from '../../../../../models/paged-search.model';
import { IconActionComponent } from '../../../shared/icon-action/icon-action.component';

/**
 * Presentational serverside-paged accounts table. All state lives in `AccountsStore`;
 * the table only emits filter/page/sort changes and row actions (View / Edit / Delete).
 */
@Component({
    selector: 'r1-accounts-table',
    templateUrl: './accounts-table.component.html',
    styleUrls: ['./accounts-table.component.scss'],
    imports: [
        MatFormField,
        MatLabel,
        MatInput,
        MatTableModule,
        IconActionComponent,
        MatSort,
        MatSortHeader,
        MatPaginator,
        DatePipe,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountsTableComponent {
    accounts = input.required<Account[]>();
    totalElements = input.required<number>();
    pageIndex = input.required<number>();
    pageSize = input.required<number>();
    sortField = input.required<string>();
    sortOrder = input.required<PagedSearch['sortOrder']>();
    selectedId = input<number | null>(null);

    filterChange = output<string>();
    pageChange = output<PageEvent>();
    sortChange = output<Sort>();
    viewAccount = output<Account>();
    editAccount = output<Account>();
    deleteAccount = output<Account>();

    readonly displayedColumns = ['name', 'id', 'createdAt', 'updatedAt', 'actions'];
    readonly pageSizeOptions = [25, 50, 100];

    #debounce: ReturnType<typeof setTimeout> | null = null;

    onFilter(value: string) {
        if (this.#debounce) {
            clearTimeout(this.#debounce);
        }
        this.#debounce = setTimeout(() => this.filterChange.emit(value), 300);
    }
}
